<h6 mat-dialog-title class="d-flex align-items-center mb-0">
  <mat-icon class="mr-2">laptop</mat-icon>
  {{ 'inventory.popups.images.title' | translate }}
</h6>
<div class="popup-subtitle mb-1">
  {{ 'inventory.popups.images.subtitle' | translate }}
</div>
<mat-divider></mat-divider>

<mat-dialog-content>
  <ngb-carousel #carousel *ngIf="imageUrls.length > 0" class="main-carousel">
    <ng-template ngbSlide *ngFor="let imageUrl of imageUrls; let i = index">
      <div class="carousel-image-wrapper">
        <img [src]="imageUrl" alt="Image" class="carousel-image" />
      </div>
    </ng-template>
    <button type="button" class="carousel-control-prev">
      <span class="carousel-control-prev-icon"></span>
    </button>
    <button type="button" class="carousel-control-next">
      <span class="carousel-control-next-icon"></span>
    </button>
    <div class="row" *ngFor="let imageUrl of imageUrls; let i = index">
      <div class="col">
        <div class="carousel-indicators">
          <button
            *ngFor="let imageUrl of imageUrls; let i = index"
            [class.active]="i.toString() === carousel.activeId"
            (click)="carousel.select(i.toString())"
            [attr.aria-label]="'Go to slide ' + (i + 1)"
            class="thumbnail-btn"
          >
            <img [src]="imageUrl" alt="Thumbnail" class="thumbnail-image" />
          </button>
        </div>
      </div>
    </div>
  </ngb-carousel>

  <!-- Thumbnail indicators below the carousel -->
  <!--If there are no results-->
</mat-dialog-content>

<mat-dialog-actions align="end">
  <div *ngIf="imageUrls.length > 0"></div>
  <button mat-flat-button class="button-style" (click)="onClose()">
    Close
  </button>
</mat-dialog-actions>
